import React from "react";
import linkedin from "../../assets/images/product-comparision/LinkedIn.png";
import zoominfo from "../../assets/images/product-comparision/ZoomInfo.png";
import apollo from "../../assets/images/product-comparision/apollo.png";
import rocketReach from "../../assets/images/product-comparision/rocketReach.png";
import lusha from "../../assets/images/product-comparision/lusha.png";
import uplead from "../../assets/images/product-comparision/uplead.png";

const comparisons = [
  {
    logo: linkedin,
    name: "LinkedIn",
    desc: "LinkedIn helps with professional networking and prospect discovery, but it lacks advanced sales automation and email marketing tools. BeyondLeadz combines lead generation, email campaigns, and CRM integration in one platform, delivering AI-driven insights and a seamless experience—all at a more affordable price.",
  },
  {
    logo: zoominfo,
    name: "ZoomInfo",
    desc: "ZoomInfo provides robust contact data but is expensive and requires additional tools for marketing and CRM. Leadhead offers comparable data accuracy with integrated email marketing, advanced automation, and user-friendly tools—all at a fraction of the cost, making it the smarter, more comprehensive choice.",
  },
  {
    logo: apollo,
    name: "Apollo.io",
    desc: "Apollo.io is great for startups but lacks depth for scaling businesses. Leadhead takes the lead with AI-powered automation, superior data accuracy, and scalable features that grow with your needs. With Leadhead, you get a complete, intuitive solution for sales and marketing success.",
  },
  {
    logo: rocketReach,
    name: "RocketReach",
    desc: "RocketReach is limited to contact lookup, while Leadhead transforms contacts into actionable leads. With built-in automation, CRM integration, and AI-driven insights, Leadhead offers everything you need to engage, nurture, and convert prospects—making it far more versatile and impactful.",
  },
  {
    logo: lusha,
    name: "Lusha",
    desc: "Lusha focuses on contact data but doesn’t offer tools to engage or convert leads. Leadhead combines contact enrichment with email marketing, CRM integration, and AI-powered insights, offering an all-in-one platform to streamline your sales and marketing efforts.",
  },
  {
    logo: uplead,
    name: "Uplead",
    desc: "UpLead focuses on accurate lead data but lacks advanced sales automation and marketing tools. Leadhead goes beyond just data by combining AI-powered lead scoring, email marketing, and CRM integration in one seamless platform. It’s not just about finding leads—it’s about converting them efficiently and affordably.",
  },
];

const CompareCRM = () => {
  return (
    <section className="tw-py-20 lg:tw-py-28 tw-bg-slate-50/50 tw-border-t tw-border-solid tw-border-slate-100" id="crm-comparison">
      <div className="tw-max-w-7xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">
        
        {/* Section Header */}
        <div className="tw-text-center tw-mb-16">
          <span className="tw-inline-flex tw-items-center tw-gap-2 tw-text-xs tw-font-bold tw-text-[#5D44FF] tw-uppercase tw-tracking-widest tw-mb-4 tw-bg-indigo-50 tw-px-4 tw-py-1.5 tw-rounded-full tw-border tw-border-solid tw-border-indigo-100">
            <span className="tw-w-1.5 tw-h-1.5 tw-rounded-full tw-bg-[#5D44FF] tw-inline-block" />
            CRM Head-To-Head
          </span>
          <h2 className="tw-text-3xl sm:tw-text-4xl tw-font-extrabold tw-text-slate-900 tw-leading-tight">
            Compare the Top CRMs
          </h2>
        </div>

        {/* Card Grid */}
        <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-8">
          {comparisons.map((item, idx) => (
            <div
              key={idx}
              className="tw-group tw-relative tw-overflow-hidden tw-bg-white tw-border tw-border-solid tw-border-slate-100 tw-rounded-3xl tw-p-8 tw-shadow-sm hover:tw-shadow-xl hover:tw-scale-[1.02] tw-transition-all tw-duration-300 tw-text-left tw-flex tw-flex-col"
            >
              {/* Logo Icon (No background container) */}
              <div className="tw-h-10 tw-flex tw-items-center tw-mb-6">
                <img
                  src={item.logo}
                  alt={item.name}
                  className="tw-h-7 sm:tw-h-8 tw-w-auto tw-object-contain"
                  loading="lazy"
                />
              </div>

              {/* Text content */}
              <h3 className="tw-text-lg tw-font-bold tw-text-slate-800 tw-mb-3">
                BeyondLeadz vs <span className="tw-text-[#5D44FF]">{item.name}</span>
              </h3>
              <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-m-0">
                {item.desc}
              </p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default CompareCRM;
